<template>
  <ContentSection :class="conditionalSpacing">
    <Container
      class="group grid gap-8 lg:grid-cols-2 lg:gap-11"
      indent="lg-but-on-mobile-default"
      :class="data.image_position.value === 'right' ? 'right' : 'left'"
    >
      <!-- IMAGE -->
      <div class="size-full max-h-[60vh] group-[.left]:-order-1 group-[.right]:order-1">
        <AppImage
          v-if="data.image"
          v-animate-zoom-in
          :src="data.image"
          class="size-full object-cover"
          :style="`object-position: ${data.image.focus_css};`"
          :alt="useMapAltText(data.image)"
        />
      </div>
      <!-- TEXT -->
      <div
        v-if="data.text"
        v-animate-in-from-bottom
        class="wysiwyg group-[.left]:order-1 group-[.left]:lg:pl-18 group-[.right]:-order-1"
        :class="{ 'lg:mt-10': data.image }"
        v-html="data.text"
      />
    </Container>
  </ContentSection>
</template>

<script setup lang="ts">
import type { ComponentsMainImageWithTextFragment } from '#gql'

const props = defineProps<{
  data: Enforce<ComponentsMainImageWithTextFragment>
  prevComponent?: string | null
  nextComponent?: string | null
}>()

const conditionalSpacing = useConditionalSpacing(
  props.prevComponent,
  props.nextComponent,
)
</script>
